<ion-list mode="ios" lines="none" class="list-content">
  <ion-item lines="none" mode="md" color="transparent" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600 title"
    >
      {{ componentProps.title| translate }}
    </ion-label>
  </ion-item>

  <!-- ? Imagen -->
  <ion-item lines="none" mode="md" color="transparent">
    <ion-icon name="warning-outline" color="danger" class="warning"></ion-icon>
  </ion-item>

  <!-- * Descripción -->
  <ion-item lines="none" mode="md" color="transparent" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="description"
      [innerHTML]=" componentProps.description | translate: componentProps.smsCountDown| htmlSeguro"
    >
    </ion-label>
  </ion-item>

  <!-- * Telefonos -->
  <ion-item-group>
    <ion-item
      lines="none"
      mode="md"
      color="transparent"
      class="ion-text-center"
    >
      <ion-label
        mode="md"
        color="status-icon-enable"
        class="description"
        [innerHTML]=" 'Labels.need-more-help' | translate | htmlSeguro"
      >
      </ion-label>
    </ion-item>

    <ion-grid class="ion-no-padding grid-phones">
      <ion-row>
        <ng-container
          *ngFor="let tel of 'Miscellaneous.support-counters' | translate; let i = index;"
        >
          <ion-col [size]="i === 0 ? 12 : 5.9" class="col-phones">
            <ion-button
              class="mpe-button-link-simple buton-phone-label"
              [ngClass]="{'phone-0': i === 0, 'phone-1': i === 1, 'phone-2': i === 2}"
              size="default"
              mode="md"
              fill="clear"
              color="tpcta"
              [href]="tel.phone_click"
            >
              <ion-label
                mode="md"
                color="tpcta"
                class="mpe-font-weight-600 phone-label"
              >
                {{ tel.phone }}
              </ion-label>
            </ion-button>
          </ion-col>

          <ng-container
            *ngIf="i > 0 && (i+1) < ('Miscellaneous.support-counters' | translate).length"
          >
            <ion-col size="0.2" class="col-phones">
              <ion-label mode="md" color="status-icon-enable">·</ion-label>
            </ion-col>
          </ng-container>
        </ng-container>
      </ion-row>
    </ion-grid>
  </ion-item-group>

  <!-- ? Botones -->
  <ion-item lines="none" mode="md" color="transparent" class="item-button">
    <ion-button size="default" mode="md" color="tpcta" (click)="onClick(true)">
      <ion-label mode="md"> {{ 'Buttons.accept' | translate }} </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
